<template>
  <div>
    <van-cell title="手机号">
      <template #default>
        <div class="phone-row">
          <span>{{ phone || '--' }}</span>
          <button type="button" :disabled="!orderId || sending || secondsLeft > 0" @click="sendCode">
            {{ secondsLeft > 0 ? `${secondsLeft}s` : '发送验证码' }}
          </button>
        </div>
      </template>
    </van-cell>
    <van-field
      :value="value"
      label="验证码"
      type="digit"
      maxlength="6"
      placeholder="请输入验证码"
      input-align="right"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import { sendChangeCompleteSms } from "@/api/changeComplete";

export default {
  name: "PhoneVerification",
  props: {
    phone: { type: [String, Number], default: "" },
    orderId: { type: [String, Number], default: "" },
    value: { type: String, default: "" },
  },
  data() {
    return {
      sending: false,
      secondsLeft: 0,
      timer: null,
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    sendCode() {
      if (!this.orderId || this.sending || this.secondsLeft > 0) return;
      this.sending = true;
      sendChangeCompleteSms({ order_id: this.orderId })
        .then((res) => {
          if (res && res.code) {
            this.$toast("验证码已发送");
            this.secondsLeft = 120;
            this.timer = setInterval(() => {
              this.secondsLeft -= 1;
              if (this.secondsLeft === 0) clearInterval(this.timer);
            }, 1000);
          } else {
            this.$toast(res.msg || '验证码发送失败，请稍后重试');
          }
        })
        .catch(() => {
          // The request helper displays the server error.
        })
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>

<style scoped lang="less">
.phone-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;

  button {
    padding: 0;
    border: 0;
    background: transparent;
    color: #577bb5;
    white-space: nowrap;
  }

  button:disabled {
    color: #999;
  }
}
</style>
